module.exports = __webpack_public_path__ + "img/icon-escrow.12e486a7.svg";